@layer components {
  .select {
    position: relative;
    display: flex;
    flex-direction: column;
    max-width: 250px;
    -webkit-user-select: none;
    user-select: none;

    &:nth-child(odd) {
      width: 25%;
    }

    &:nth-child(even) {
      width: 50%;
    }
  }

  .value {
    composes: field from '../styles/field.module.css';
    display: flex;
    border-radius: var(--radius);

    /* Fokus ma przycisk w środku, a podświetlamy całe pole. */
    &:has(:focus-visible) {
      background-color: var(--blue);
      color: var(--white);
    }

    &:has([aria-disabled="true"]) {
      pointer-events: none;
    }
  }

  .trigger {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: 0;
    padding: var(--space-small);
    padding-right: 0;
    border-radius: inherit;
  }

  /* Otwarty select: pole do wpisywania wygląda jak podświetlony przycisk. Selektor jest mocniejszy
     od `.field`, który trafia do CSS później i nadpisywał tło (stąd mignięcie po kliknięciu). */
  .select > .open {
    background-color: var(--blue);
    color: var(--white);
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    cursor: text;
  }

  /* Bez `width: 0` pole ma domyślną szerokość ok. 20 znaków i na wąskim ekranie poszerza select. */
  .input {
    flex: 1;
    width: 0;
    min-width: 0;
    text-overflow: ellipsis;
    padding: var(--space-small);
    padding-right: 0;

    /* Fokus widać po zmianie tła całego pola. */
    &:focus-visible {
      outline: none;
    }

    &::placeholder {
      color: inherit;
      opacity: 0.75;
    }

    &::selection {
      background-color: var(--white);
      color: var(--navy);
    }
  }

  .toggle {
    display: flex;
    align-items: center;
  }

  .text {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .icon {
    flex-shrink: 0;
    width: 30px;
  }
}
